import React from "react"
import { styled } from "@mui/material"
import { COLORS } from "../../utils"

const StyledBox = styled("div")({
  flex: "0 0 96px",
  position: "relative",
  bottom: 0,
  width: "100%",
  marginTop: "auto",
})

const RightAction = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  flex: 1,
})

const StyledContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "fixed",
})(({ fixed }) => ({
  width: "100%",
  height: "auto",
  display: "flex",
  borderTop: `1px solid ${COLORS.DEFAULT_GREY}`,
  backgroundColor: "#fff",
  position: fixed ? "fixed" : "relative",
  left: fixed ? 0 : undefined,
  right: fixed ? 0 : undefined,
  bottom: fixed ? 0 : undefined,
  zIndex: fixed ? 1200 : undefined,
  background: fixed ? "#fff" : undefined,
  padding: fixed ? "24px !important" : "0 20px"
}))

const PackagingExecutionFooter = ({ rightAction = null, className, fixed = false }) => {
  return (
    <StyledBox className={className}>
      <StyledContainer fixed={fixed}>
        {rightAction && <RightAction>{rightAction}</RightAction>}
      </StyledContainer>
    </StyledBox>
  )
}

export default PackagingExecutionFooter
